
const EXPERTS_LIMIT = 10
export default {
  scrollToTop: true,
  async asyncData({ $axios, route, error }) {
    try {
      const stream = await $axios.$get(`/stream/${route.params.url}/profile`)

      if (stream?.stream?.type !== 'THEMATIC') {
        error({
          statusCode: 404,
          message: 'Журнал не найден',
        })
      }

      const [
        popularExperts,
        { events, countAllPublishedEvents },
        { offers, countAllPublishedOffers },
        { articles, countAllPublishedArticles },
        { videos, countAllPublishedVideos },
        collections,
      ] = await Promise.all([
        $axios.$get('/experts/streams/recomended', {
          params: {
            streams: [stream.stream.id],
            limit: EXPERTS_LIMIT,
          },
        }),
        $axios.$get(`/advertisements/stream/events/${stream.stream.url}`, {
          params: {
            limit: 2,
          },
        }),
        $axios.$get(`/advertisements/stream/offers/${stream.stream.url}`, {
          params: {
            limit: 2,
          },
        }),
        $axios.$get(`/articles/stream/article/${stream.stream.url}/popular`, {
          params: {
            limit: 2,
          },
        }),
        $axios.$get(`/articles/stream/video/${stream.stream.url}/popular`, {
          params: {
            limit: 2,
          },
        }),
        $axios.$get(`/collection/stream/${stream.stream.id}`),
      ])
      return {
        stream,
        collections,
        popularExperts,
        events,
        countAllPublishedEvents,
        offers,
        countAllPublishedOffers,
        articles,
        countAllPublishedArticles,
        videos,
        countAllPublishedVideos,
      }
    } catch (err) {
      const statusCode = err.response?.data?.statusCode
      const message = err.response?.data?.message
      error({
        statusCode,
        message,
      })
    }
  },
  data() {
    return {
      stream: null,
      collections: [],
      popularExperts: [],
    }
  },
  computed: {
    isAdmin() {
      return !!this.$auth?.user?.roles?.some((role) =>
        ['ADMIN', 'MODERATOR'].includes(role)
      )
    },
  },
  methods: {
    async changeStreamCover(cover) {
      this.stream.stream.cover = cover
      this.stream.stream._id = this.stream.stream.id
      await this.saveStream()
    },
    async updateStreamAvatar(avatar) {
      this.stream.stream.avatar = avatar
      this.stream.stream._id = this.stream.stream.id
      await this.saveStream()
    },

    async saveStream() {
      await this.$axios.$put('/stream', this.stream.stream)
      await this.fetchStream()
    },

    subscribe() {
      this.$eventBus.$emit('Stream-subscribe', this.stream.stream)
      this.fetchStream()
    },
    unSubscribe() {
      this.$eventBus.$emit('Stream-unSubscribe', this.stream.stream)
      this.fetchStream()
    },

    async fetchStream() {
      this.stream = await this.$axios.$get(
        `/stream/${this.$route.params.url}/profile`
      )
    },
    updateChild() {
      console.log('test updateChild')
      this.fetchStream()
      console.log(this.stream.statistics.videosCount)
    },
  },
}
